<template>
  <div class="bottom_tree_table">
    <div class="bottom_left">
      <major-tree @detailBtn="detailBtn"></major-tree>
    </div>
    <div class="bottom_right">
      <div class="right_table">
        <el-table :data="personTable" border highlight-current-row
          style="width: 100%; height: 100%" height="100%">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              暂无数据
            </p>
          </template>
          <el-table-column label="文件名称" prop="fileName" min-width="200px" />
          <el-table-column label="文件大小(b)" prop="fileSize" />
          <el-table-column label="Revit版本" prop="revitVersion" />
          <el-table-column label="所属公司" prop="depName" />
          <el-table-column label="修改时间" prop="updateDate" min-width="120px" />
          <el-table-column label="上传人" prop="userName" />
          <el-table-column label="备注" prop="remark" min-width="150px" show-overflow-tooltip />
          <el-table-column label="操作" width="120px">
            <template slot-scope="scope">
              <span style="cursor: pointer;color:var(--theme-color)" @click="downloadFile(scope.row)">下载</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import majorTree from "@/CommonDP/components/structure/majorTree.vue";
import revitService from "@/CommonDP/service/revitTemplate-service";
import { disablePrompt } from "@/CommonDP/utils/routeAuth";
import { getEnterpriseId } from "@/CommonDP/utils/auth";
export default {
  components: { majorTree },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      personTable: []
    };
  },
  computed: {
    enterpriseId() {
      return getEnterpriseId("enterpriseId");
    }
  },
  methods: {
    detailBtn(val) {
      this.getrevitList(val.specId);
    },
    // 获取图层
    async getrevitList(item) {
      this.fileID = undefined;
      const params = {
        id: item,
        enterpriseId: this.enterpriseId
      };
      const res = await revitService.getrevitSystemModelMaintenanceList(params);
      this.personTable = res.data || [];
    },

    // 下载
    async downloadFile(row) {
      const a = disablePrompt();
      if (a) {
        revitService.downloadDepartmentNameFile(row.fileID).then((response) => {
          if (response.type === "application/json") {
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
              const jsonData = JSON.parse(fileReader.result);
              // 后台信息
              this.$message({ message: jsonData.message, type: "error" });
            };
            fileReader.readAsText(response); // 或者读取response.data
          } else {
            const link = document.createElement("a");
            const blob = new Blob([response], {
              type: "application/octet-stream"
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(row.fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
$top-button-height: 42px;
$middle-height: 30px;
$left-width: 256px;
.bottom_tree_table {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  .bottom_left {
    position: absolute;
    top: 10px;
    bottom: 10px;
    left: 0;
    width: $left-width;
    border-right: 1px solid #ebefff;
    .left_tree {
      overflow: auto;
      position: absolute;
      left: 0;
      top: 10px;
      bottom: 10px;
      right: 0;
      li {
        display: flex;
        border-bottom: 0;
        align-items: center;
        padding: 2px 30px;
        cursor: pointer;
        font-size: 14px;
        line-height: 26px;
        color: var(--key-color);
        img {
          margin-right: 8px;
        }
      }
      .active {
        background: rgba(85, 132, 255, 0.1);
      }
    }
  }
  .bottom_right {
    position: relative;
    height: 100%;
    margin-left: $left-width + 10px;
    .right_button {
      height: $top-button-height;
      padding: 10px;
    }
    .right_table {
      position: absolute;
      top: $top-button-height + 10px;
      left: 10px;
      bottom: 40px;
      right: 20px;
    }
  }
  .centerTree {
    overflow: auto;
    margin-top: 10px;
    height: 500px;
    padding-left: 12px;
    border-right: 1px solid rgb(209, 206, 206);
    .tree_1 {
      font-size: 14px;
    }
  }
}
/deep/.el-tree-node__content {
  height: 31px;
  line-height: 31px;
}
/deep/.el-divider--horizontal {
  margin: 10px 0;
}
</style>
